/**
 * Servy answers only from the unit guide files the host uploads. The unit
 * details (qr-code) list them as knowledge_base.file_links; without any upload
 * the knowledge base is null or has no links and Servy has nothing to answer
 * from, so the guest isn't offered it.
 */
export const hasServyKnowledgeBase = (unitDetails) => {
  const links = unitDetails?.knowledge_base?.file_links;
  return Array.isArray(links) && links.length > 0;
};
